import { jsx as n, jsxs as o } from "react/jsx-runtime";
import { useRef as r, useState as m, useEffect as u } from "react";
import { SNACKBAR_ROOT as d } from "../../utils/popups.js";
import { C as f } from "../../cancel@2x-Dzl_P7Hv.js";
import '../../assets/SnackBar.css';function T(e) {
  const a = r(null), [s, i] = m(null);
  u(() => (l(), a.current?.showModal(), () => a.current?.close()), []);
  const c = () => {
    clearTimeout(s), d.unmount();
  }, l = () => {
    if (e.timer) {
      const t = setTimeout(() => c(), e.timer);
      i(t);
    }
  };
  return /* @__PURE__ */ n("dialog", { className: "snackbar-modal-dialog", onClose: c, ref: a, children: /* @__PURE__ */ n(
    "div",
    {
      className: `snackbar-container ${e.messageType}-container`,
      onMouseEnter: () => e.ignoreMouse ? null : clearTimeout(s),
      onMouseLeave: () => l(),
      children: /* @__PURE__ */ o("div", { children: [
        /* @__PURE__ */ n("div", { className: "snackbar-info-container", children: /* @__PURE__ */ o("div", { className: "flow", style: { "--flow-gap": "0.5em" }, children: [
          e.title ? /* @__PURE__ */ n("h5", { className: "snackbar-title", children: e.title }) : null,
          /* @__PURE__ */ o("h5", { className: "snackbar-message", children: [
            " ",
            e.message
          ] })
        ] }) }),
        /* @__PURE__ */ n("div", { children: /* @__PURE__ */ n("img", { src: f, onClick: () => c(), alt: "close icon", id: "close-snackbar-icon" }) })
      ] })
    }
  ) });
}
export {
  T as default
};
